<div class="center text-overflow">
    <div class="text-center text-overflow" [class._input]="!readonly" *ngIf="!focus">
        <a [href]="value" target="_blank">{{value}}</a>
    </div>
    <input #input class="text-center" type="text" [value]="value" placeholder="www.url.com" *ngIf="focus" (blur)="setFocus(false)" (change)="emitValue(input.value); setFocus(false)">
</div>